import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import Faq from '../../Models/Faq';
import GetFaqResponse, { GetFaqTranslationsResponse } from '../Responses/FaqResponse';
import GetPaginatedResponse from '../Responses/PaginatedResponse';

export type ChangeOrderDirection = 'up' | 'down';

class FaqsApi extends AbstractCRMApi {
    public endpoint: string = 'faq';

    public getById(id: number): Promise<Faq> {
        return this.get(`/${id}`).then((response: AxiosResponse<GetFaqResponse>) =>
            FaqsApi.mapDataToFaqClass(response.data)
        );
    }

    public getAll(
        page: number = 1,
        isAgent: boolean = false,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<Faq>> {
        return this.get('', {
            ...config,
            params: {
                ...config?.params,
                page,
                is_agent: isAgent ? 'true' : 'false',
            },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetFaqResponse>>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, Faq);
        });
    }

    public store(faq: Faq): Promise<Faq> {
        return this.post('', faq).then((response: AxiosResponse<GetFaqResponse>) =>
            FaqsApi.mapDataToFaqClass(response.data)
        );
    }

    public update(faq: Faq): Promise<Faq> {
        return this.patch(`/${faq.id}`, faq).then((response: AxiosResponse<GetFaqResponse>) =>
            FaqsApi.mapDataToFaqClass(response.data)
        );
    }

    public async changeOrder(faqId: number, direction: ChangeOrderDirection): Promise<Faq> {
        const response = await this.post(`/change_order/${faqId}/${direction}`);

        return AbstractCRMApi.mapDataToFaqClass(response.data);
    }

    public getTranslations(): Promise<GetFaqTranslationsResponse> {
        return this.get('/translations').then((response: AxiosResponse<GetFaqTranslationsResponse>) => response.data);
    }
}

export default new FaqsApi();
